export default __webpack_public_path__ + "static/media/AppStoreButton.647dab43.png";